@if(isBrowser()) {
@if(!isDisabled) {
@if(list[0]){
<div class="header">
    <span multilang class="title">Ausgewählte Filter</span>
    <button class="clearall" (click)="resetAll()">Alle Filter löschen</button>
</div>
<div class="sel-wrapper">
    <ng-container *ngFor="let fl of list">
        <div class="selected-item">
            <span multilang style="font-size:14px;font-weight:400;color:var(--coraldarkgrey);">{{fl.name }}</span>
            <button (click)="this[fl.function](fl.index)">
                <mat-icon class="clearbtn">clear</mat-icon>
            </button>
        </div>
    </ng-container>
</div>
}
}
}